import React from 'react';
import { exportDataToCsv } from '../utils/exportCsv';

// Floating "Export CSV" button. Renders fixed at the bottom-right so it can be
// dropped anywhere in a page's JSX without disturbing existing layout.
// Only shows when there is data to export.
export default function ExportCsvButton({ data, filename, label }) {
  const hasData =
    data !== null &&
    data !== undefined &&
    !(Array.isArray(data) && data.length === 0) &&
    !(typeof data === 'object' && !Array.isArray(data) && Object.keys(data).length === 0);

  if (!hasData) return null;

  const handleClick = () => {
    exportDataToCsv(data, filename || 'export');
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      title="Download this data as CSV"
      style={{
        position: 'fixed',
        bottom: '24px',
        right: '24px',
        zIndex: 9999,
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        padding: '10px 16px',
        background: '#4f46e5',
        color: '#fff',
        border: 'none',
        borderRadius: '9999px',
        boxShadow: '0 4px 14px rgba(0,0,0,0.2)',
        fontSize: '14px',
        fontWeight: 600,
        cursor: 'pointer'
      }}
    >
      <span aria-hidden="true">&#8681;</span>
      {label || 'Export CSV'}
    </button>
  );
}
